__turbopack_context__.v({
  "active": "Seszbq_active",
  "circle": "Seszbq_circle",
  "color": "Seszbq_color",
  "dark": "Seszbq_dark",
  "root": "Seszbq_root",
  "selected": "Seszbq_selected",
  "swatch-item": "Seszbq_swatch-item",
  "swatch-item-color": "Seszbq_swatch-item-color",
  "swatch-item-disabled": "Seszbq_swatch-item-disabled",
  "text": "Seszbq_text",
});
